module.exports = __webpack_public_path__ + "static/logo2-bcf83d150537bba5cdd6683394714336.png";